import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import MunicipalidadHeader from '../components/Header/MunicipalidadHeader';
import './GirsuView.css';

const GirsuView = () => {
  return (
    <>
      <MunicipalidadHeader
        tipo="Ciudadano"
        title={
          <img
            className="girsu-header-logo"
            src="/assets/images/logo-girsu.png"
            alt="GIRSU"
          />
        }
      ></MunicipalidadHeader>
      <Container className="content pagina-interna">
        <h5>Separación domiciliaria y recolección diferenciada</h5>
        <p className="girsu-intro">
          Villa La Angostura avanza hacia una comunidad más limpia, consciente y sustentable a través
          del Programa GIRSU (Gestión Integral de Residuos Sólidos Urbanos).
        </p>

        <h5>Días de recolección</h5>
        <Row>
          <Col lg="6" md="12">
            <div className="girsu-box girsu-box-reciclables">
              <div className="girsu-box-title">Reciclables — Miércoles y Jueves</div>
              <p>
                Papel y cartón, plásticos, vidrio, latas y envases reciclables.
              </p>
              <p className="girsu-importante">
                Importante: los reciclables deben entregarse limpios y secos.
              </p>
            </div>
          </Col>
          <Col lg="6" md="12">
            <div className="girsu-box girsu-box-no-reciclables">
              <div className="girsu-box-title">No reciclables — Lunes, Martes y Viernes</div>
              <p>
                Restos de comida, residuos sanitarios, servilletas usadas y materiales no
                recuperables.
              </p>
            </div>
          </Col>
        </Row>

        <h5>Tus residuos sí importan</h5>
        <div className="girsu-box">
          <p>
            Separar correctamente los residuos tiene impacto directo en los recursos disponibles
            para toda la comunidad.
          </p>
          <p>Cuando reciclamos, ayudamos a:</p>
          <ul className="girsu-list">
            <li>Reducir la contaminación.</li>
            <li>Recuperar materiales reutilizables.</li>
            <li>Mejorar la gestión de residuos.</li>
            <li>Optimizar recursos municipales.</li>
            <li>Cuidar el ambiente y nuestro futuro.</li>
          </ul>
        </div>

        <h5>¿Sabías que?</h5>
        <div className="girsu-box">
          <p>
            En la Planta de Transferencia de Residuos de Villa La Angostura se preparan fardos y
            lotes de:
          </p>
          <ul className="girsu-list">
            <li>Cartón</li>
            <li>Plásticos</li>
            <li>Aluminio</li>
          </ul>
          <p>
            Estos materiales luego son vendidos y los ingresos obtenidos se destinan directamente al
            Fondo GIRSU, fortaleciendo programas ambientales, equipamiento y mejoras en el sistema
            de gestión de residuos.
          </p>
        </div>

        <h5>Reutilizar también es cuidar</h5>
        <div className="girsu-box">
          <p>Algunas ideas simples para reutilizar en casa:</p>
          <ul className="girsu-list">
            <li>Los potes limpios pueden convertirse en macetas.</li>
            <li>Los envases de huevo de cartón sirven para almácigos y huertas.</li>
            <li>Las latas pueden reutilizarse como organizadores.</li>
            <li>Las cajas de cartón pueden utilizarse para guardado o compostaje.</li>
          </ul>
          <p className="girsu-cierre">
            Entre todos podemos construir una Villa La Angostura más limpia, responsable y
            sustentable.
          </p>
        </div>

        <div className="girsu-contacto">
          <div className="girsu-contacto-title">Contacto</div>
          <div>Dirección de Residuos: 2944-241657</div>
          <div>Secretaría de Servicios Públicos</div>
        </div>
      </Container>
    </>
  );
};

export default React.memo(GirsuView);
